import { render, staticRenderFns } from "./nsHeaderFooter.vue?vue&type=template&id=4d2249ed&"
import script from "./nsHeaderFooter.vue?vue&type=script&lang=js&"
export * from "./nsHeaderFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports